import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle } from "@components";
import "./BestServiceList.scss";
import { BestServiceAPI, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import HeaderSection from "../../../common/components/Header/HeaderSection";
import LandingCardBox from "../../../common/components/LandingCardBox";
import { TitleComponent } from "../../../common/components/TitleComponent";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const BestServiceListContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const BestServiceList = function ({ props }) {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(false);

  const { id } = props;

  useEffect(() => {
    setisLoading(true);
    loadShortDescData();
  }, []);

  const loadData = async function () {
    const { data } = await BestServiceAPI(`?cat=${id}`);    
    if (id === "individu") {
      const grouped = {
        label_perorangan: [],
        label_layanan_lainnya: [],
        label_nogroup: [],
      };

      data.data.map((item) => {
        let key = "label_nogroup";
        if ([2127, 1186, 2129, 2130, 2131, 1187].indexOf(item.id) > -1) {
          key = "label_perorangan";
        } else if ([3495, 2132, 2133].indexOf(item.id) > -1) {
          key = "label_layanan_lainnya";
        }

        grouped[key].push(
          <div className="col-lg-4">
            <Desktop>
              <LandingCardBox
                title={item.title}
                image={item.imageBannerDesktop}
                redirectUrl={`/${id}-service/${item.id}`}
              />
            </Desktop>
            <Mobile>
              <LandingCardBox
                title={item.title}
                image={item.imageBannerMobile}
                redirectUrl={`/${id}-service/${item.id}`}
              />
            </Mobile>
          </div>
        );
      });

      setdata(grouped);
    } else {
      setdata(data.data);
    }
  };

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: id });    
    setShortDesc(data.data ? data.data[0] : "");
    loadData();
    setisLoading(false);
  };
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <HeaderSection
          title={shortDesc.title}
          group={t('LayananTerbaikUntukAnda')}
          description={shortDesc.description}
          banner={shortDesc.banner}
        />
      </Container>

      <BestServiceListContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t('PilihJenisLayanan')}</h4>
                </div>
              </div>
              <div className="row mt-2">
                {id === "individu"
                  ? Object.keys(data).map((group) => {
                      const items = data[group];
                      if (items.length == 0) return false;

                      return (
                        <div className="mb-5">
                          <h5 className="mb-4 section-title">{t(group)}</h5>
                          <div className="row ">{items}</div>
                        </div>
                      );
                    })
                  : data.map((item) => {
                      return (
                        <div className="col-lg-4">
                          <Desktop>
                            <LandingCardBox
                              title={item.title}
                              description={item.description}
                              image={item.imageBannerDesktop}
                              redirectUrl={`/${id}-service/${item.id}`}
                            />
                          </Desktop>
                          <Mobile>
                            <LandingCardBox
                              title={item.title}
                              description={item.description}
                              image={item.imageBannerMobile}
                              redirectUrl={`/${id}-service/${item.id}`}
                            />
                          </Mobile>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      </BestServiceListContainer>
      <FooterSection currentPage={t("layanan_individual")} />
    </div>
  );
};

export default BestServiceList;
